// Sample mnemonics data
export const sampleMnemonics = [
  {
    id: 1,
    subject: "Physics",
    chapter: "Thermodynamics",
    concept: "Laws of Thermodynamics",
    mnemonic: "You can't win, you can't break even, you can't quit the game (First, Second, Third laws)",
  },
  {
    id: 2,
    subject: "Chemistry",
    chapter: "Electrochemistry",
    concept: "Electrochemical Series",
    mnemonic:
      "Kings Can Only Find Gold After Several Copper Mines (K, Ca, Na, Mg, Al, Zn, Fe, Sn, Pb, H, Cu, Hg, Ag, Au)",
  },
{
  id: 3,
   subject: "Math",
    chapter: "Trigonometry",
    concept: "Trigonometry Table",
  mnemonic: "Trick to memorize sin cos tan cosec sec tan table",
  image: "", // optional
  video: "", // optional
  steps: [
  "$$\\text{Assign numbers to standard angles} \\quad 0^\\circ, 30^\\circ, 45^\\circ, 60^\\circ, 90^\\circ \\to 0, 1, 2, 3, 4$$",
  "$$\\text{Divide each number by 4} \\quad \\frac{0}{4}, \\frac{1}{4}, \\frac{2}{4}, \\frac{3}{4}, \\frac{4}{4} = 0, \\frac{1}{4}, \\frac{1}{2}, \\frac{3}{4}, 1$$",
  "$$\\text{Take the square root to get } \\sin \\theta \\quad \\sin \\theta = \\sqrt{\\frac{n}{4}} \\text{ for } n = 0, 1, 2, 3, 4 \\quad \\Rightarrow \\sin 0^\\circ = \\sqrt{0} = 0, \\quad \\sin 30^\\circ = \\sqrt{\\frac{1}{4}} = \\frac{1}{2}, \\quad \\sin 45^\\circ = \\sqrt{\\frac{2}{4}} = \\frac{\\sqrt{2}}{2}, \\quad \\sin 60^\\circ = \\sqrt{\\frac{3}{4}} = \\frac{\\sqrt{3}}{2}, \\quad \\sin 90^\\circ = \\sqrt{1} = 1$$",
  "$$\\text{Use the complementary angle identity for } \\cos \\theta \\quad \\cos \\theta = \\sin(90^\\circ - \\theta) \\quad \\Rightarrow \\cos 0^\\circ = \\sin 90^\\circ = 1, \\quad \\cos 30^\\circ = \\sin 60^\\circ = \\frac{\\sqrt{3}}{2}, \\quad \\cos 45^\\circ = \\sin 45^\\circ = \\frac{\\sqrt{2}}{2}, \\quad \\cos 60^\\circ = \\sin 30^\\circ = \\frac{1}{2}, \\quad \\cos 90^\\circ = \\sin 0^\\circ = 0$$",
  "$$\\text{Calculate } \\tan \\theta = \\frac{\\sin \\theta}{\\cos \\theta} \\quad \\tan 0^\\circ = \\frac{0}{1} = 0, \\quad \\tan 30^\\circ = \\frac{\\frac{1}{2}}{\\frac{\\sqrt{3}}{2}} = \\frac{1}{\\sqrt{3}}, \\quad \\tan 45^\\circ = \\frac{\\frac{\\sqrt{2}}{2}}{\\frac{\\sqrt{2}}{2}} = 1, \\quad \\tan 60^\\circ = \\frac{\\frac{\\sqrt{3}}{2}}{\\frac{1}{2}} = \\sqrt{3}, \\quad \\tan 90^\\circ = \\frac{1}{0} = \\text{undefined}$$",
  "$$\\text{Use reciprocals for } \\csc \\theta, \\sec \\theta, \\cot \\theta \\quad \\csc \\theta = \\frac{1}{\\sin \\theta}, \\quad \\sec \\theta = \\frac{1}{\\cos \\theta}, \\quad \\cot \\theta = \\frac{1}{\\tan \\theta} \\quad \\Rightarrow \\csc 0^\\circ = \\frac{1}{0} = \\text{undefined}, \\quad \\csc 30^\\circ = \\frac{1}{\\frac{1}{2}} = 2, \\quad \\csc 45^\\circ = \\frac{1}{\\frac{\\sqrt{2}}{2}} = \\sqrt{2}, \\quad \\csc 60^\\circ = \\frac{1}{\\frac{\\sqrt{3}}{2}} = \\frac{2}{\\sqrt{3}}, \\quad \\csc 90^\\circ = \\frac{1}{1} = 1, \\quad \\sec 0^\\circ = \\frac{1}{1} = 1, \\quad \\sec 30^\\circ = \\frac{1}{\\frac{\\sqrt{3}}{2}} = \\frac{2}{\\sqrt{3}}, \\quad \\sec 45^\\circ = \\frac{1}{\\frac{\\sqrt{2}}{2}} = \\sqrt{2}, \\quad \\sec 60^\\circ = \\frac{1}{\\frac{1}{2}} = 2, \\quad \\sec 90^\\circ = \\frac{1}{0} = \\text{undefined}, \\quad \\cot 0^\\circ = \\frac{1}{0} = \\text{undefined}, \\quad \\cot 30^\\circ = \\frac{1}{\\frac{1}{\\sqrt{3}}} = \\sqrt{3}, \\quad \\cot 45^\\circ = \\frac{1}{1} = 1, \\quad \\cot 60^\\circ = \\frac{1}{\\sqrt{3}} = \\frac{1}{\\sqrt{3}}, \\quad \\cot 90^\\circ = \\frac{1}{\\text{undefined}} = 0$$"
]
},
{
  id: 4,
  subject: "Math",
  chapter: "Trigonometry",
  concept: "Signs of Trigonometric Functions in Quadrants",
  mnemonic: "All Students Take Calculus",
  image: "https://i.postimg.cc/4xS2XQ2S/Screenshot-20250522-112429-Chrome.png",
  video: "",
  steps: [
    "Quadrant I: All functions are positive.",
    "Quadrant II: Sine and cosecant are positive.",
    "Quadrant III: Tangent and cotangent are positive.",
    "Quadrant IV: Cosine and secant are positive."
  ]
},
{
  id: 5,
  subject: "Math",
  chapter: "Trigonometry",
  concept: "Basic Trigonometric Ratios",
  mnemonic: "SOH-CAH-TOA",
  image: "",
  video: "",
  steps: [
    "Sine = Opposite / Hypotenuse",
    "Cosine = Adjacent / Hypotenuse",
    "Tangent = Opposite / Adjacent"
  ]
},
]
